"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOwnerOfAssignment = exports.DbAssignmentSchema = exports.DbAssignmentPinSchema = void 0;
const pins_shared_1 = require("@lessonup/pins-shared");
const zod_1 = require("zod");
exports.DbAssignmentPinSchema = zod_1.z.discriminatedUnion('type', [
    pins_shared_1.QuizPinSchema,
    pins_shared_1.SlidePinSchema,
]);
exports.DbAssignmentSchema = pins_shared_1.DbLessonSchema.omit({ user: true }).merge(zod_1.z.object({
    ownerId: zod_1.z.string(),
    pins: zod_1.z.record(zod_1.z.string(), exports.DbAssignmentPinSchema),
    createdAt: zod_1.z.number(),
    modifiedAt: zod_1.z.number(),
}));
function isOwnerOfAssignment(userId, assignment) {
    return assignment.ownerId === userId;
}
exports.isOwnerOfAssignment = isOwnerOfAssignment;
//# sourceMappingURL=db-assignment.js.map